<template>
	<div class="p-l-l p-r-xl relative">
		<input
			type="text"
			v-model="search_query"
			class="left primary2-color"
			placeholder="Search your solar PV plant"
		/>
		<font-awesome-icon
			icon="search"
			id="header-search"
			class="absolute primary2-color"
		/>

		<div
			v-if="query_results.length > 0"
			id="search_results"
			class="overflow-y-scroll"
		>
			<div
				v-for="(element, index) in query_results"
				v-bind:key="'search_list_' + index"
				@click="
					add_new_location(
						element.name,
						element.position[0],
						element.position[1]
					)
				"
			>
				<span>{{ element.full_name }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import Geosearch from "@/services/Geosearch";

export default {
	name: "Search",
	data() {
		return {
			search_query: "",
			query_results: []
		};
	},
	methods: {
		add_new_location: function(name, lng, lat) {
			//Go to new location
			this.$router.push({
				name: "add-new",
				query: {
					lat: lat,
					lng: lng,
					name: name
				}
			});
			this.$root.$emit("new_location_sended", [lat, lng]);
			this.query_results = [];
			this.search_query = "";
		}
	},
	watch: {
		search_query: async function(val) {
			const results = await Geosearch.query_seach(val);
			this.query_results = results;
		}
	}
};
</script>

<style>
#search input {
	width: 95%;
	height: 28px;
	border: none;
	font-size: 17px;
	font-weight: 300;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: normal;
	z-index: 9;
}
#search input::placeholder {
	opacity: 0.8;
	color: var(--primary2);
}
#header-search {
	top: 7px;
	right: 15px;
	font-size: 19px;
	z-index: 9;
}

#search_results {
	position: absolute;
	width: 100%;
	height: 300px;
	background-color: white;
	top: 30px;
	left: 0;
	color: black;
}
#search_results > div {
	text-align: left;
	padding: 12px 15px;
	cursor: pointer;
	border-bottom: 1px solid black;
}
#search_results > div:hover {
	background-color: grey;
}
</style>
